export const ListSparkle = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.125 15.2096H6.04167M3.125 10.0013H7.70833M3.125 4.79297H16.875M14.1667 8.7513L15.4167 11.2513L17.9167 12.5013L15.4167 13.7513L14.1667 16.2513L12.9167 13.7513L10.4167 12.5013L12.9167 11.2513L14.1667 8.7513Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ListSparkle
